import React from 'react';

import { useTranslation } from 'react-i18next';

import { CouponFilledIcon } from '@icons';

import { Button } from '@components/button';

import * as Styled from './tickets-card.styled';

type OwnProps = {
	ticketsAmount: number;
	onClick: () => void;
};

const TicketsCard: React.FC<OwnProps> = ({ ticketsAmount, onClick }) => {
	const { t } = useTranslation('promotions');

	return (
		<Styled.Wrapper>
			<Styled.Content>
				<Styled.Title>{t('tickets')}</Styled.Title>
				<Styled.CountRow>
					<Styled.CountText>{t('ticketsAmount')}:</Styled.CountText>
					<Styled.CountNumber>
						{ticketsAmount}

						<Styled.TicketIconWrapper>
							<CouponFilledIcon />
						</Styled.TicketIconWrapper>
					</Styled.CountNumber>
				</Styled.CountRow>
				<Button onClick={onClick} color='primary' size='large'>
					{t('tickets_buy')}
				</Button>
			</Styled.Content>
		</Styled.Wrapper>
	);
};

export default TicketsCard;
